var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrcid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "22px",
    viewBox: "0 0 21 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "36A76749-C7B3-438B-AFE7-94200BF0B954") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Login",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login-Page-Form-3",
    transform: "translate(-926.000000, -729.000000)",
    fill: "#A6CE39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login",
    transform: "translate(900.000000, 147.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social-buttons",
    transform: "translate(0.000000, 448.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social-button-3",
    transform: "translate(0.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "orcid-",
    transform: "translate(26.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.51074661,19.5300896 L12.1924661,19.5300896 C17.4172308,19.5300896 18.6113801,15.4512239 18.6113801,13.411791 C18.6113801,10.0976716 16.5713348,7.29316418 12.0931946,7.29316418 L8.56054299,7.29316418 L8.56054299,19.5300896 L8.51106787,19.5300896 L8.51074661,19.5300896 Z M6.22171946,5.25373134 L12.441448,5.25373134 C18.3627195,5.25373134 21,9.58773134 21,13.4626866 C21,17.6945672 17.7658054,21.6716418 12.4912443,21.6716418 L6.22171946,21.6716418 L6.22171946,5.25373134 Z",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.0778009,1.54771642 C3.0778009,2.42508955 2.37101357,3.09592537 1.56334842,3.09592537 C0.705244344,3.09592537 0.0488959276,2.37353731 0.0488959276,1.54771642 C0.0488959276,0.722223881 0.755683258,-0.000164179105 1.56334842,-0.000164179105 C2.42145249,-0.000164179105 3.0778009,0.722223881 3.0778009,1.54771642 L3.0778009,1.54771642 Z M2.72440724,21.6714776 L0.402289593,21.6714776 L0.402289593,5.05655224 L2.72440724,5.05655224 L2.72440724,14.2929403 L2.72440724,21.6714776 Z",
    id: "Fill-5"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrcid);
export default __webpack_public_path__ + "static/media/orcid.a5d82103.svg";
export { ForwardRef as ReactComponent };